<div if.bind="report.panelOpen" class="modal-overlay" click.trigger="report.closePanel()">
  <div class="daily-releases-admin" click.trigger="$event.stopPropagation()">
    <div class="daily-releases-admin__header">
      <h3 class="daily-releases-admin__title">Daily Releases</h3>
      <button type="button" class="daily-releases-admin__close" click.trigger="report.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="daily-releases-admin__body">
      <p class="daily-releases-admin__hint">
        The hours of the day (your local time) when each source tends to publish new releases. Use the arrows to move between days.
      </p>

      <div class="daily-releases-admin__nav">
        <button type="button" class="daily-releases-admin__arrow" click.trigger="report.goPreviousDay()" disabled.bind="report.loading" aria-label="Previous day">&#9664;</button>
        <span class="daily-releases-admin__day">${report.selectedDayLabel}</span>
        <button type="button" class="daily-releases-admin__arrow" click.trigger="report.goNextDay()" disabled.bind="report.loading || report.isToday" aria-label="Next day">&#9654;</button>
      </div>

      <div if.bind="report.error" class="daily-releases-admin__error">${report.error}</div>

      <div class="daily-releases-admin__chart-viewport">
        <div class="daily-releases-admin__chart-slide" ref="slide" show.bind="!report.error">
          <canvas ref="canvas" class="daily-releases-admin__canvas"></canvas>
        </div>
        <div if.bind="report.loading" class="daily-releases-admin__overlay">Loading releases&hellip;</div>
        <div if.bind="!report.loading && !report.error && !report.hasReleases"
             class="daily-releases-admin__overlay">
          No releases were first seen on this day.
        </div>
      </div>
    </div>
  </div>
</div>
